<template lang="pug">
  div.classifier.standards
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showYear="false"
      :showActual="true"
      :showCol="false"
      :showViewPanel="false"
      :showTotal="true"
      :hasTariffYearSelect="true"
      @letSearch="search"
      @changeTariffYearSelect='changeYearSelect'
      :showExport="true"
      :endpointExport="getExportPoint"
    )
    e-table(
      :items="items"
      :showCheckbox="false"
      :actionColumnWidth="110"
      @deleteItem="deleteItem"
      @editItem="editItem"
    )

    router-view
</template>

<script>
import { garbage, export_document } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import year from '@/utils/year'

export default {
  name: 'standardsLayout',
  mixins: [tableMixin],
  data: () => ({
    year: year.getCurrentYear(),
  }),
  computed: {
    meta() {
      return this.items?._meta || { fields: {} }
    },
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler() {
        this.updateTableState()
      },
    },
  },
  methods: {
    updateTableState() {
      if (Object.keys(this.meta).length > 0) {
        this.$sharedServices.store.commit('tableState', {
          id: 'access.standardsLayout',
          param: 'meta',
          data: this.meta,
        })
      }
    },
    getEndpoint(route) {
      route.query.year = this.year || year.getCurrentYear()
      return garbage.normatives(route)
    },
    getDeleteUrl(id) {
      return garbage.normative(id)
    },
    changeYearSelect(year) {
      this.year = year
      this.getItemsWithYear(year)
    },
    async getItemsWithYear(year, search = this.$route.query.q) {
      const route = this.$route
      route.query.year = year
      route.query.q = search || ''
      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: garbage.normatives(route),
      })
      this.$store.commit('mutateEndpoint', {
        endpoint: garbage.normatives(route),
        response,
      })
    },
    search(search) {
      this.getItemsWithYear(this.year, search)
    },
    getExportPoint() {
      return export_document.normative(this.$route)
    },
  },
}
</script>
